import { MedicationSearchListItem, SearchMedication } from "@/Patient/Components/Medication/SearchMedication";
import { MedicationHelper } from "@/Patient/Helpers/MedicationHelper";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";

import styles from "./SearchMedicationContainer.module.scss";

import img_icon_delete from "@/Globals/_images/icons/delete.png";

interface ISearchMedicationContainerProps {
    selectedCode: string;
    isSearchingMedication: boolean;
    newMedication: MedicationModel;
    searchingMedicationName: string;
    searchingMedicationEventId: string;
    onItemSelect: (response: MedicationSearchListItem) => void;
    onBlur: (customMedictionName: string) => void;
    onDeleteClick: () => void;
}

export function SearchMedicationContainer(props: ISearchMedicationContainerProps): JSX.Element {
    return (
        <>
            {(!MedicationHelper.isMeidcationReplaced(props.selectedCode) || !props.isSearchingMedication) && props.newMedication != null &&
                <div><span className={styles.newMedicationLabel}>{props.newMedication.GetName()}</span></div>
            }
            {MedicationHelper.isMeidcationReplaced(props.selectedCode) && props.isSearchingMedication && (
                <SearchMedication
                    debounce={200}
                    newValue={props.searchingMedicationName}
                    newValueEventId={props.searchingMedicationEventId}
                    onItemSelect={(response: MedicationSearchListItem) => props.onItemSelect(response)}
                    onBlur={(customMedictionName: string) => props.onBlur(customMedictionName)}
                    disableIndicator
                    disableFavorites
                    dataCy="searchMedicationContainer-search"
                />
            )}
            {MedicationHelper.isMeidcationReplaced(props.selectedCode) && !props.isSearchingMedication && (
                <div
                    className={styles.deleteIconContainer}
                    onClick={e => {
                        props.onDeleteClick();
                        e.stopPropagation();
                    }}
                >
                    <img alt="change medication" className={`file-img ${styles.deleteIcon}`} src={img_icon_delete} aria-expanded="false" />
                </div>
            )}
        </>
    );
}
